import { useLocation } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PromotionContent from 'modules/marketplace_modules/components/PromotionContent'

const ModulesPromotionsPage = () => {
  const location = useLocation()
  const upsellOrigin = new URLSearchParams(location.search).get('upsell_origin')

  useEffect(() => {
    track(trackingEvents.marketplaceModules.visitModulesPromotionPage, {
      upsell_origin: upsellOrigin,
      promotion: 'black_friday',
    })
  }, [upsellOrigin])

  return (
    <ResponsivePage.Body>
      <PromotionContent />
    </ResponsivePage.Body>
  )
}

export default ModulesPromotionsPage
